<template>
	<EditOverlay
		ref="overlay"
		class="overlay--editDate"
		:title="overlayTitle"
		:submitName="submitName"
		:root="true"
		@apply="_onApplyClick"
		@close="_onCloseClick"
		@afterhide="afterhide"
	>
		<div class="datePicker datePicker-measurement">
			<div class="datepicker-container inline-with-input">
				<input
					id="datepicker-inline-trigger"
					type="text"
					placeholder="Select date"
					:value="currentValue"
				>
				<airbnb-style-datepicker
					:key="dateKey"
					:trigger-element-id="'datepicker-inline-trigger'"
					:mode="'single'"
					:inline="true"
					:fullscreen-mobile="false"
					:show-action-buttons="true"
					:date-one="currentValue"
					:months-to-show="1"
					@date-one-selected="val => currentValue = val"
					:enabled-dates="enabledDates"
					:minDate="minDate"
				/>
			</div>

			<InfoBox v-if="infoBox" :type="infoBox.type" :withIcon="infoBox.withIcon" :class="infoBox.class">
				{{ infoBox.message }}
			</InfoBox>
		</div>
	</EditOverlay>
</template>

<script src="./EditDateOverlay.js"></script>